module.exports = __webpack_public_path__ + "static/Image17@2x-769f692a1dbf55adbac4214f755e5e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image17@2x.jpg
// module id = 910
// module chunks = 227233210825294 244429959259914